import type { Capability, PermissionMatrix } from '../../types/settings';

export const capabilities: Capability[] = [
  { id: 'lezen', label: 'Lezen', hint: 'Gegevens in eigen domein bekijken' },
  { id: 'concept', label: 'Concept maken', hint: 'Iets voorbereiden zonder het te versturen' },
  { id: 'versturen', label: 'Versturen', hint: 'Namens jou mailen, posten of indienen' },
  { id: 'agenda', label: 'Agenda', hint: 'Afspraken en focusblokken wijzigen' },
  { id: 'huis', label: 'Huis bedienen', hint: 'Licht, klimaat, apparaten' },
  { id: 'cloud', label: 'Cloudmodel', hint: 'Werk naar de Claude API sturen' },
  { id: 'beveiliging', label: 'Sloten en alarm', hint: 'Vaste regel: dat doe je altijd zelf', locked: true },
  { id: 'geld', label: 'Betalen', hint: 'Vaste regel: geld verplaats je altijd zelf', locked: true },
  { id: 'verwijderen', label: 'Verwijderen', hint: 'Vaste regel: niets definitief weggooien', locked: true },
];

const fixed = { beveiliging: 'nooit', geld: 'nooit', verwijderen: 'nooit' } as const;

export const defaultPermissions: PermissionMatrix = {
  code: { lezen: 'zelf', concept: 'zelf', versturen: 'naOk', agenda: 'nvt', huis: 'nvt', cloud: 'naOk', ...fixed },
  mail: { lezen: 'zelf', concept: 'zelf', versturen: 'naOk', agenda: 'nvt', huis: 'nvt', cloud: 'zelf', ...fixed },
  slack: { lezen: 'zelf', concept: 'zelf', versturen: 'naOk', agenda: 'nvt', huis: 'nvt', cloud: 'zelf', ...fixed },
  agenda: { lezen: 'zelf', concept: 'zelf', versturen: 'naOk', agenda: 'naOk', huis: 'nvt', cloud: 'zelf', ...fixed },
  boekhouding: { lezen: 'zelf', concept: 'zelf', versturen: 'naOk', agenda: 'nvt', huis: 'nvt', cloud: 'nooit', ...fixed },
  huis: { lezen: 'zelf', concept: 'nvt', versturen: 'nvt', agenda: 'nvt', huis: 'zelf', cloud: 'nooit', ...fixed },
  studio: { lezen: 'zelf', concept: 'zelf', versturen: 'naOk', agenda: 'nvt', huis: 'nvt', cloud: 'naOk', ...fixed },
  initiatief: { lezen: 'zelf', concept: 'zelf', versturen: 'naOk', agenda: 'naOk', huis: 'tenzijBezwaar', cloud: 'zelf', ...fixed },
};
